import { useCallback, useEffect, useState } from 'react';
import { FEATURES } from '@belong/feature-toggles';
import { useFeatureToggles } from '@belong/feature-toggles/hooks';
import { clearKeyFromSessionStorage, getValuesFromSessionStorage } from '@belong/session-storage';
import { REGISTER_SESSION_KEYS } from '../components/Register/constants';

interface IUseProspectUserEmail {
  initialEmail: string | undefined;
  clearProspectUserEmail: () => void;
}

export const useProspectUserEmail = (clearAfterLoad = false): IUseProspectUserEmail => {
  const [initialEmail, setInitialEmail] = useState<string>();
  const featureToggles = useFeatureToggles();
  const isNbnServerSideResumptionEnabled = featureToggles.isFeatureOn(FEATURES.NBN_SERVER_SIDE_RESUMPTION_EMAIL);

  const clearProspectUserEmail = useCallback(() => {
    if (initialEmail) {
      clearKeyFromSessionStorage(REGISTER_SESSION_KEYS.PROSPECT_EMAIL);
    }
  }, [initialEmail]);

  useEffect(() => {
    if (!isNbnServerSideResumptionEnabled) {
      return;
    }

    const storedValue = getValuesFromSessionStorage<string>(REGISTER_SESSION_KEYS.PROSPECT_EMAIL);

    if (!storedValue) {
      return;
    }

    setInitialEmail(storedValue);

    if (clearAfterLoad) {
      clearProspectUserEmail();
    }
  }, [isNbnServerSideResumptionEnabled, clearAfterLoad, clearProspectUserEmail]);

  return {
    initialEmail,
    clearProspectUserEmail
  };
};
